const WEBSOCKET_ROUTE_NAME = {
	MY_OPERATION: 'myOperation',
	DELETE_CONNECTION: 'deleteConnectionUserInfo',
	UPDATE_CONNECTION: 'updateConnectionUserInfo',
};

export default WEBSOCKET_ROUTE_NAME;
